import { Actions, CHANGE_THEME, ThemeName } from './types';

export const changeTheme = (theme: ThemeName): Actions => ({
  type: CHANGE_THEME,
  payload: theme,
});
